<template>
  <div :class="{ 'with-mobile-nav': showGlobalNav }">
    <!-- Conditionally render the header based on the route and authentication status -->
    <AppHeader v-if="!isLoginPage" />
    <main class="app-content">
      <router-view />
    </main>
    <MobileBottomNav :show-nav="showGlobalNav" />
    <ToastContainer />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'; // Header Component
import MobileBottomNav from './components/MobileBottomNav.vue';
import ToastContainer from './components/ToastContainer.vue';

export default {
  name: 'App',
  components: {
    AppHeader,
    MobileBottomNav,
    ToastContainer
  },
  computed: {
    isLoginPage() {
      return (
        ['/login', '/changePassword', '/landingPage'].includes(this.$route.path) ||
        this.$route.name === 'LandingPage'
      );
    },
    showGlobalNav() {
      return !this.isLoginPage;
    }
  },
};
</script>

<style>
:root {
  --app-max-width: 1200px;
  --app-gutter: 24px;
  --app-header-h: 78px;
  --mobile-nav-h: 90px;
}

@media (max-width: 1199px) {
  :root {
    --app-gutter: 18px;
  }
}

@media (max-width: 767px) {
  :root {
    --app-gutter: 12px;
    --app-header-h: 64px;
  }
}

body * {
  margin: 0;
}

@media (max-width: 767px) {
  .app-content {
    background: transparent;
    flex: 1 0 auto;
  }

  .with-mobile-nav {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding-bottom: 0;
    background: transparent;
  }
}

html,
body,
#app {
  background: #181a20;
}
</style>
